module.exports = __webpack_public_path__ + "static/media/blog-single.7a776cef.png";